<template>

</template>

<script>
import C from '../lib/config'
export default {
    name:'logout',
    created(){
        location.href=C.adminHost + 'leemmaCustomer'
    }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// logout.vue?356d625a